class LengthFormatter {
  public static UNIT: any = {
    INCH: 'inch',
    FOOT: 'foot',
  }
  public static inchToFoot(n: any): any {
    if (!n) {
      return null
    }
    return (parseFloat(n) / 12).toFixed(2)
  }
  public static footToInch(n: any): any {
    if (!n) {
      return null
    }
    return (parseFloat(n) * 12).toFixed(2)
  }
}

export default LengthFormatter
